import {
  GeckoComponentDataFrame,
  GeckoMeasurementUnit,
  GeckoSource,
  GeckoView,
  GeckoViewCategory,
} from 'types'

export interface CdfDisplayMetadata {
  label: string
  description: string
  category: GeckoViewCategory
}

type CdfDisplayMetadataInput = {
  data: {
    params: Pick<GeckoComponentDataFrame['data']['params'], 'source' | 'view'> &
      Partial<Record<string, unknown>>
  }
}

export function getCdfDisplayMetadata(
  cdf: CdfDisplayMetadataInput,
  displayMeasurementUnit: GeckoMeasurementUnit
): CdfDisplayMetadata {
  const { source, view } = cdf.data.params

  let label = view.name
  let description = view.description
  let category = view.category

  if (
    view === GeckoView.DifferenceFromNominal &&
    displayMeasurementUnit.id === GeckoMeasurementUnit.Percent.id
  ) {
    label = 'Difference from Nominal %'
    description = 'Percentage-based difference between thickness and nominal'
  } else if (view === GeckoView.DifferenceFromNominalProjection) {
    label = `Difference from Nominal (${displayMeasurementUnit.name})`
    description = 'Unit-based difference between thickness and nominal'
  }

  if (source === GeckoSource.Projection) {
    category = GeckoViewCategory.DERIVED
  }

  return { label, description, category }
}

export function getCdfDisplayTitle(
  cdf: CdfDisplayMetadataInput,
  displayMeasurementUnit: GeckoMeasurementUnit
): string {
  const workflowDisplayName = cdf.data.params.forecast_display_name
  if (typeof workflowDisplayName === 'string' && workflowDisplayName.trim()) {
    return workflowDisplayName.trim()
  }

  const { label } = getCdfDisplayMetadata(cdf, displayMeasurementUnit)

  return label === cdf.data.params.view.name
    ? `${label} (${displayMeasurementUnit.name})`
    : label
}
